import {
  CardBody,
  GridLayout,
  GridLayoutItem,
} from '@progress/kendo-react-layout';
import { BaseButton } from 'app/components/buttons/BaseButton';
import { ChevronRightIcon } from 'app/components/icons';
import { getDefaultThumbnail } from 'app/pages/Equipment/utils';
import IntelIcon from 'assets/images/ic_equipment_intellattach_small.svg';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumberWithDecimals } from 'utils/general';
import './SmartAttachmentModelDescription.less';

export interface SmartAttachmentModelDescriptionProps {
  name?: string;
  model?: string;
  pin?: string;
  isAttachmentOwner: boolean;
  userEnteredEngineHours?: number;
  imageUrl: string;
  showChevron?: boolean;
  onClick?: () => void;
}

export function SmartAttachmentModelDescription({
  name,
  model,
  pin,
  isAttachmentOwner,
  userEnteredEngineHours = 0,
  imageUrl,
  showChevron,
  onClick,
}: SmartAttachmentModelDescriptionProps) {
  const { t, i18n } = useTranslation();

  const getEngineHours = () => {
    if (userEnteredEngineHours > 0) {
      return aproximateToTwoHours(userEnteredEngineHours);
    }

    return '0';
  };

  const aproximateToTwoHours = num => {
    const currentEngineHours = Math.round(num * 100) / 100;
    return i18n.language === 'fr'
      ? formatNumberWithDecimals(currentEngineHours, 2).replace(
          '.',
          t('hours_separator'),
        )
      : formatNumberWithDecimals(currentEngineHours, 2);
  };

  return (
    <>
      <CardBody>
        <div className="row">
          <div className="col-xxs-3">
            <img
              src={imageUrl}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = getDefaultThumbnail(
                  'attachment',
                  undefined,
                );
              }}
              alt=""
              className="equipment-list-image"
            />
          </div>
          <div className="col-xxs-9">
            <div className="smart-attachment-model-description__name-block">
              <span className="equipment-list-nickname" title={name}>
                <img style={{ width: '24px' }} src={IntelIcon} alt="Intel" />
                <span>{name}</span>
              </span>

              {showChevron && (
                <BaseButton
                  className="smart-attachment-model-description__chevron-right"
                  onClick={onClick}
                >
                  <ChevronRightIcon />
                </BaseButton>
              )}
            </div>
            <GridLayout
              rows={[{ height: '5' }, { height: '5' }]}
              cols={[{ width: '25%' }, { width: '75%' }]}
              className="inline-label-text"
            >
              <GridLayoutItem className="label">
                {t('equipment_model')}
              </GridLayoutItem>
              <GridLayoutItem className="text">{model}</GridLayoutItem>
              <GridLayoutItem className="label">
                {t('equipment_serial')}
              </GridLayoutItem>
              <GridLayoutItem className="text">{pin}</GridLayoutItem>
              {isAttachmentOwner && (
                <>
                  <GridLayoutItem className="label">
                    {t('equipment_hours')}
                  </GridLayoutItem>
                  <GridLayoutItem className="text">
                    {getEngineHours()}
                  </GridLayoutItem>
                </>
              )}
            </GridLayout>
          </div>
        </div>
      </CardBody>
    </>
  );
}
